// Sub-menu items per category. These are placeholder lists — easy to edit later.
// Each item is a string. If you want price/details, expand to { name, note }.

export const ITEMS = {
  liquor: [
    "Whisky", "Vodka", "Tequila", "Gin", "Rum", "Cognac",
    "Mickeys (375ml)", "26ers (750ml)", "1.14L Bottles", "Premium $100+ bottles",
  ],
  wine: ["Red", "White", "Rosé", "Champagne / Sparkling", "Boxed wine"],
  "cali-brick": ["Cali Brick 7g — $70", "Cali Brick 14g — $120"],
  indica: ["Indica 7g — $50"],
  sativa: ["Sativa 7g — $50"],
  "oz-deals": ["Oz 28g — $100"],
  hash: ["Hash 7g — $50"],
  "nic-vapes": ["Pulse", "Ovns", "STLTH"],
  "thc-vapes": ["Gas Gang — $50"],
  shatter: ["Shatter 1g — $50"],
  shrooms: ["Shrooms 7g — $50"],
  edibles: ["Gummies", "Chocolates", "Cookies", "Brownies", "Beverages"],
  prerolls: ["Indica pre-rolls", "Sativa pre-rolls", "Hybrid pre-rolls", "Blunts", "Hash-infused"],
  "shisha-tobacco": ["Double apple — $25", "Lemon mint — $25", "Mint — $25", "Gum mint — $25", "Grape mint — $25", "Orange mint — $25", "Blueberry mint — $25"],
};
